<template>
	<div>
		<div class="page-event-details">
			<div class="banne-img">
				<img src="../assets/750x520.png" alt="">
				<!-- <img :src="formData.image" alt=""> -->
			</div>
			<div class="p030">
				<div class="title-row fcc-h">
					<div class="h1">
						{{ formData.name }}
					</div>
					<div class="sub">
						{{ formData.assistantName }}
					</div>
					<div class="line"></div>
					<div class="des" style="min-height: 120px">
						{{ formData.ruleContent }}
					</div>
				</div>
			</div>
  
			<!-- 勋章 -->
			<div class="medal-list" :style="'grid-template-columns: repeat(' + medalRowNum + ', 1fr)'">
				<div class="item" v-for="(item, index) in medalTotal" :key="index" >
					<img src="../assets/xz2.png" alt="" srcset="" v-if="index < userFormData">
					<img src="../assets/xz.png" alt="" srcset="" @click="showcheckInBoxFun()" v-else>
				</div>
			</div>

			<!-- 当前打卡 -->
			<div class="dk-activity-total fc-bet" @click="gotoCouponFun">
				<div class="icon">
					<img src="../assets/icon90.png" alt="" />
				</div>
				<div class="txt flex1">
					<div>
						当前打卡：{{ userFormData }}/{{ medalTotal }}
					</div>
					<div>
						您有<span class="b">{{ userCouponFormData.length }}</span>个活动券
					</div>
				</div>
				<i class="link-arrow"></i>
			</div>
		</div>

    <van-overlay :show="showcheckInBox" z-index="999" @click="showcheckInBox = false" @touchstart="handleTouchStart">
      <div class="fcc-h checkin-pop" style="height: 100vh;">
        <div class="fcc-h" style="width:90%;height: 45vh;" @click.stop>
          <div class="logo-wrap fcc">
            <div class="img fcc">
              <img src="../assets/logoicon.png" alt="" srcset="" />
            </div>
          </div>
          <div class="p fcc">
            请在屏幕上盖章
          </div>
        </div>
      </div>
    </van-overlay>

    <van-overlay :show="showLoading">
      <div class="fcc-h " style="height: 100vh;">
        <van-loading size="24px" vertical color="#fff">加载中...</van-loading>
      </div>
    </van-overlay>
    <van-overlay :show="load" @click="load = false">
        <div class="fcc-h " style="height: 100vh;" @click="load = false">
          <div class="brand-logo fcc rotateing">
            <div class="circle"></div>
            <img src="../assets/logoicon.png" alt="" />
          </div>
        </div>
      </van-overlay>
    <div style="position:fixed;left: 110%;top: 110%;width: 0;height: 0;overflow: hidden">
      <!--      <video src="@/assets/audio/duang.mp3"  ref="audio"  controls></video>-->
      <audio id="audioID" ref="audio" class="aud">
        <source src="https://oss-pai-s2lxmtw6mbk6ofo9ye-cn-shanghai.oss-cn-shanghai.aliyuncs.com/images/duang.mp3" type="audio/mp3" />
      </audio>
    </div>
	</div>
</template>

<script>
import { getRedeemList, getTotal, queryActive, activeSignIn } from "@/api/api";
import moment from "moment";
import { check } from "@/utils/check"

export default {

	data() {
		return {
			//勋章总数
			medalTotal: 5,
			//勋章每行5个
			medalRowNum: 5,
			activityId: 0,
			formData: {},
			productFormData: {},
			userFormData: 0,
			userCouponFormData: [],
      showLoading: false,
      checking:false,
      showcheckInBox: false,
      load: false
		}
	},
	async mounted() {
		//获取url参数
		console.log('token', this.$route.query.token);
		console.log('token', this.$route.query.activityId);
		if (this.$route.query.token) {
			await window.localStorage.setItem('token', this.$route.query.token)
		}
		if (this.$route.query.activityId) {
			this.activityId = this.$route.query.activityId
			this.queryActiveFun()
		}
    this.$nextTick(() => {
			let Media = document.getElementById("audioID");
			Media.src = "https://oss-pai-s2lxmtw6mbk6ofo9ye-cn-shanghai.oss-cn-shanghai.aliyuncs.com/images/duang.mp3";
		})
	},
	methods: {
    moment,
		async queryActiveFun() {
      let self = this
      self.showLoading = true
			queryActive(this.activityId).then(res => {
				console.log(res);
				this.formData = res.data
				this.productFormData = res.data.product
				this.medalTotal = this.formData.signatureTotalNum
				this.medalRowNum = this.formData.signatureRowNum
				this.getRedeemListFun()
				this.getTotalFun()
			}).finally(f=>{
        self.showLoading = false
      })
		},
		getRedeemListFun() {
			getRedeemList(this.formData.productId).then(res => {
				console.log('优惠券', res);
				this.userCouponFormData = res.data
			})
		},
		getTotalFun() {
			getTotal(this.activityId).then(res => {
				console.log(res);
				this.userFormData = res.data
			})
		},
		gotoCouponFun() {
      if(!this.userCouponFormData || this.userCouponFormData.length == 0){
        this.$toast("暂无活动券")
      }else{
        this.$router.push({ path: '/coupons?productId=' + this.formData.productId })
      }
		},
    showcheckInBoxFun() {
      this.showcheckInBox = true
    },
    async handleTouchStart(event) {
      if (event.touches.length != 4) {
        return
      }
      // 获取触摸点的坐标
      let touchArr = []
      for (let i = 0; i < event.touches.length; i++) {
        var touchX = event.touches[i].clientX;
        var touchY = event.touches[i].clientY;
        let touchItem = [touchX, touchY]
        touchArr.push(touchItem)
      }
      let scope = check(touchArr)
      console.log("盖章：", scope)
      if (!scope) {
        // that.$toast("打卡失败，请重试")
        return
      }
      if (scope) {
        if (this.checking) {
          return
        }
        this.checking = true
        this.showcheckInBox = false
			  this.load = true
        let requestData = {
          activeId: this.activityId,
          signatureTime: moment().format('YYYY-MM-DD HH:mm:ss')
        }
        let res = await activeSignIn(requestData)
        if (res.success) {
          document.querySelector('audio').play()
					document.getElementById("audioID").play()
          this.load = false
          this.$toast("打卡成功！")
          this.queryActiveFun()
        } else {
          this.$toast(res.message)
        }
        this.checking = false
      }
    },
	},


}
</script>

<style scoped="scoped" lang="less">
.brand-logo {
  width: 367px;
  height: 367px;

  margin: 50px auto 22px;
  position: relative;

  .circle {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: url(../assets/8bg.png) center no-repeat;
    background-size: contain;
  }

  img {
    position: relative;
    width: 205px;
    height: 205px;
    display: block;
    object-fit: contain;
  }
}

.rotateing {
  .circle {
    -webkit-animation: circle 3s linear infinite;
    animation: circle 3s linear infinite;
  }
}


@keyframes circle {
  0% {
    -webkit-transform: rotate(0) scale(1.5);
    transform: rotate(0) scale(1.5);

  }

  // 33% {
  // 	-webkit-transform: rotate(720deg) scale(1.5);
  // 	transform: rotate(720deg) scale(1.5);
  // }
  // 67% {
  // 	-webkit-transform: rotate(1080deg) scale(1.5);
  // 	transform: rotate(1080deg) scale(1.5);
  // }
  100% {
    -webkit-transform: rotate(720deg) scale(1.5);
    transform: rotate(720deg) scale(1.5);
  }
}
</style>
